import React from 'react';

import InnerAlert from '../../components/basic/Alert';

import { GENERAL_TYPES } from '../../utils/styles/constants';

const Alert = ({ message = '', ...rest }) => {
  let type = 'gray';
  if (rest.error) {
    type = 'danger';
  }
  GENERAL_TYPES.forEach(cType => {
    if (rest[cType]) type = cType;
  });
  return <InnerAlert type={type} description={message} {...rest} />;
};

export default Alert;
